<app-about-carousel></app-about-carousel>
<app-who-we-are></app-who-we-are>
<app-we-offer></app-we-offer>
<app-choose-us></app-choose-us>